import CardStatusType from "enums/CardStatusType";
import { AssignedCardUser, CardEnrollment, EnrolledCard } from "./types";

const UNENROLLED_STATUSES = new Set<string>([
  CardStatusType.CANCELED,
  CardStatusType.CLOSED,
  CardStatusType.INACTIVE,
]);

/**
 * Which cards-table tab a card belongs in. An unenrolled card stays unenrolled
 * whether or not it has a user. See README.md.
 */
export const readCardEnrollment = (
  status: string,
  assignedUser: AssignedCardUser | null,
): CardEnrollment => {
  if (UNENROLLED_STATUSES.has(status)) return "unenrolled";
  if (!assignedUser) return "unassigned";
  return "enrolled";
};

/** Case-insensitive match on anything the admin can see in a row. */
export const matchesCardSearch = (
  card: EnrolledCard,
  searchTerm: string,
): boolean => {
  const needle = searchTerm.trim().toLowerCase();
  if (!needle) return true;

  return [
    card.cardholderName,
    card.nickname,
    card.cardNumber,
    card.connectionName,
    card.assignedUser?.name,
    card.assignedUser?.email,
  ].some((value) => value?.toLowerCase().includes(needle));
};
